import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/Esp.css";

const Especialidades = () => {
  const [especialidades, setEspecialidades] = useState([]);
  const [sucursales, setSucursales] = useState([
    { id: 1, nombre: "Av. Nueva Providencia 1881, oficina 1313" },
    { id: 2, nombre: "Fidel Oteiza" },
    { id: 3, nombre: "Concepción" },
  ]);
  const [selectedSucursal, setSelectedSucursal] = useState("1");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://vortexcode.cl/api/especialidad")
      .then((response) => {
        setEspecialidades(response.data);
        setLoading(false);
      })
      .catch(() => {
        setError("Hubo un error al cargar las especialidades");
        setLoading(false);
      });
  }, []);

  const encodeName = (name) => {
    return encodeURIComponent(name.trim());
  };

  const especialidadesFiltradas = especialidades.filter(
    (esp) => esp.id_sucursal === parseInt(selectedSucursal)
  );

  const handleSucursalChange = (e) => {
    const sucursalId = e.target.value;
    setSelectedSucursal(sucursalId);

    // Navegar a la misma página con el parámetro de sucursal en la URL
    navigate(`?sucursal=${sucursalId}`);
  };

  if (loading) return <div className="text-center mt-5">Cargando...</div>;
  if (error) return <div className="alert alert-danger mt-5">{error}</div>;

  return (
    <div id="especialidades" className="py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h1 className="main-title">Nuestras Especialidades</h1>
          <p className="sub-title">Conoce las especialidades que ofrecemos</p>
        </div>

        {/* Filtro por sucursal */}
        <div className="filtroSucursal mb-4 text-center">
          <label htmlFor="sucursalSelect" className="me-2">
            Filtrar por sucursal:
          </label>
          <select
            id="sucursalSelect"
            value={selectedSucursal}
            onChange={handleSucursalChange}
            className="form-select d-inline-block w-auto"
          >
            {sucursales.map(({ id, nombre }) => (
              <option key={id} value={id}>
                {nombre}
              </option>
            ))}
          </select>
        </div>

        <div className="row">
          {especialidadesFiltradas.length > 0 ? (
            especialidadesFiltradas.map((especialidad) => (
              <div
                key={especialidad.id_especialidad}
                className="col-12 col-sm-6 col-lg-4 mb-4 d-flex"
              >
                <Link
                  to={{
                    pathname: `/especialidad/${encodeName(especialidad.nombre_especialidad)}`,
                  }}
                  state={{ sucursalId: selectedSucursal }}
                  className="text-decoration-none text-dark w-100"
                >
                  <div className="card specialty-card h-100 shadow-sm rounded-4 border-0 hover-effect">
                    <div className="card-body text-center p-4">
                      <div
                        className="iconoEspecialidad mb-3"
                        dangerouslySetInnerHTML={{ __html: especialidad.img_especialidad }}
                      />
                      <h5 className="card-title mb-3">{especialidad.nombre_especialidad}</h5>
                      <p className="card-text">{especialidad.descripcion_especialidad}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))
          ) : (
            <div className="text-center mt-5">No se encontraron especialidades</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Especialidades;